import AccountMenuNav from 'components/AccountMenu/AccountMenuNav/AccountMenuNav'
// import LanguageSelector from 'components/LanguageSelector'
import HeaderLinks from 'components/Header/HeaderLinks'

import {
  // StyledLanguageMobileWrapper,
  StyledDefaultScreenWrapper,
} from '../styles'

interface ScreenDefaultProps {
  handleScreenLanguage: () => void
  handleCloseMenu: () => void
}

function ScreenDefault(props: ScreenDefaultProps) {
  const { /*, handleScreenLanguage */ handleCloseMenu } = props

  return (
    <StyledDefaultScreenWrapper>
      <div onClick={handleCloseMenu}>
        <HeaderLinks isMobile />
      </div>

      <div onClick={handleCloseMenu}>
        <AccountMenuNav />
      </div>
      {/* <StyledLanguageMobileWrapper>
        <LanguageSelector mobileClickHandler={handleScreenLanguage} />
      </StyledLanguageMobileWrapper> */}
    </StyledDefaultScreenWrapper>
  )
}

export default ScreenDefault
